import { LoaderIcon } from "@commonlibs";
import TextField from "../TextField/TextField";
import { SearchBarProps } from "./SearchBar.types";
import { useDebounce } from "@commonlibs";
import useTranslate from "ui/locale/hooks/useTranslate";
import SearchIcon from "ui/common/icons/SearchIcon";
import clsx from "clsx";

const SearchBar = ({
    loading: loadingProp = false,
    showLoading = true,
    className,
    variant = "filled",
    size = "md",
    onChange: onSearch,
    defaultValue = "",
    hideError,
    ...rest
}: SearchBarProps): JSX.Element => {
    const translate = useTranslate();

    const { value, handleChange, debouncing } = useDebounce(defaultValue, { callback: onSearch });
    const isLoading = showLoading && (loadingProp || debouncing);

    return (
        <TextField
            className={clsx("search-bar", className)}
            value={value}
            placeholder={translate("search")}
            onChange={handleChange}
            size={size}
            suffix={isLoading ? <LoaderIcon /> : <SearchIcon />}
            hideError={hideError || isLoading || value === ""}
            {...rest}
            variant={variant}
        />
    );
};

export default SearchBar;
